import Flickity from 'flickity';
import asNavFor from 'flickity-as-nav-for';
import 'flickity-imagesloaded';
import {screen_sm} from '../theme/variables';

const arrowShape = 'M70.4999313,0c2.3032074,0,4.6064224,0.8789084,6.3637314,2.6357486\n' +
   '\t\tc3.5151138,3.5146568,3.5151138,9.2138891,0,12.7285461l-34.636013,34.6358261l34.636013,34.6363144\n' +
   '\t\tc3.5151138,3.5146561,3.5151138,9.2129135,0,12.7275696c-3.5146255,3.5146561-9.2128296,3.5146561-12.7274628,0\n' +
   '\t\tL23.1359692,56.3639069c-3.5146255-3.5146561-3.5146255-9.2134018,0-12.7280579L64.1362,2.6357486\n' +
   '\t\tC65.8935165,0.8789084,68.1967239,0,70.4999313,0z';
export function slider() {
	const galleries = document.querySelectorAll('.default-slider, .wp-default-slider');
	if (galleries.length) {
		galleries.forEach(gallery => {
			gallery.parentNode.classList.remove('visually-hidden');
			// trigger redraw for transition
			gallery.offsetHeight;
			// Flickity options, defaults
			let options = {
				prevNextButtons: false,
				contain: true,
				wrapAround: true,
				imagesLoaded: true,
				hash: true,
				adaptiveHeight: true,
				//cellSelector: '.cms-block',
				arrowShape: arrowShape
			};
			// enable prev/next buttons at 768px
			if (matchMedia('screen and (min-width: 1500px)').matches) {
				options.prevNextButtons = true;
			}
			new Flickity(gallery, options);
		});
	}
}
export function wpPostSlider() {
	const galleries = document.querySelectorAll('.wp-post-slider');
	if (galleries.length) {
		galleries.forEach(gallery => {
			gallery.parentNode.classList.remove('visually-hidden');
			// trigger redraw for transition
			gallery.offsetHeight;
			// Flickity options, defaults

            // ⚠️ DOM-Struktur anpassen: <li> → <div>, <ul> → <div>
            const list = gallery.querySelector('ul.wp-block-post-template');
            if (list) {
                const liItems = list.querySelectorAll('li.wp-block-post');
                liItems.forEach(li => {
                    const div = document.createElement('div');
                    div.className = li.className;
                    div.innerHTML = li.innerHTML;
                    li.replaceWith(div);
                });

                const newContainer = document.createElement('div');
                newContainer.className = list.className;
                newContainer.innerHTML = list.innerHTML;
                list.replaceWith(newContainer);
            }

            // Flickity options, defaults
            let options = {
                prevNextButtons: false,
                contain: true,
                wrapAround: true,
                imagesLoaded: true,
                hash: true,
                adaptiveHeight: true,
                arrowShape: arrowShape,
                cellSelector: '.wp-block-post' // 🔁 geändert: wir haben jetzt divs
            };

            // enable prev/next buttons at 1500px
            if (matchMedia('screen and (min-width: 1500px)').matches) {
                options.prevNextButtons = true;
            }

            // Neue innere Galerie (nach Umwandlung) selektieren
            const newGallery = gallery.querySelector('.wp-block-post-template');
            if (newGallery) {
                new Flickity(newGallery, options);
            }
        });
	}
}

export function heroSlider() {
   const heroSlides = document.querySelectorAll('.hero-slider');
   if (heroSlides.length) {
      heroSlides.forEach(heroSlide => {
         heroSlide.parentNode.classList.remove('visually-hidden');
         heroSlide.offsetHeight;

         let options = {
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            wrapAround: true,
            imagesLoaded: true,
            hash: true,
            adaptiveHeight: true,
            arrowShape: arrowShape
         };

         if (matchMedia('screen and (min-width: 1500px)').matches) {
            options.prevNextButtons = true;
         }

         let flkty = new Flickity(heroSlide, options);

         let cellsButtonGroup = document.querySelector('.control-group--cells');
         let previousButton = document.querySelector('.control--previous');
         let nextButton = document.querySelector('.control--next');
         let items = heroSlide.querySelectorAll('.item');

         // Dynamisch Buttons erzeugen und Titel setzen
         cellsButtonGroup.innerHTML = ''; // alte Buttons löschen
         let titles = [];

         items.forEach((item, index) => {
            let title = item.getAttribute('title');
            titles.push(title);
            let button = document.createElement('button');
            button.classList.add('button');
            if (index === 0) button.classList.add('is-selected');
            //button.textContent = title;
            button.title = title;
            cellsButtonGroup.appendChild(button);
         });

         let cellsButtons = Array.from(cellsButtonGroup.children);

         // update selected button & prev/next button text
         flkty.on('select', function () {
            let selectedIndex = flkty.selectedIndex;
            let selectedButton = cellsButtonGroup.children[selectedIndex];

            cellsButtonGroup.querySelector('.is-selected')?.classList.remove('is-selected');
            selectedButton.classList.add('is-selected');

            let prevIndex = (selectedIndex - 1 + items.length) % items.length;
            let nextIndex = (selectedIndex + 1) % items.length;

            previousButton.innerHTML = `<span>&larr;</span> ${titles[prevIndex]}`;
            nextButton.innerHTML = `${titles[nextIndex]} <span>&rarr;</span>`;
         });

         cellsButtonGroup.addEventListener('click', function (event) {
            if (!event.target.matches('.button')) return;
            let index = cellsButtons.indexOf(event.target);
            flkty.select(index);
         });

         previousButton.addEventListener('click', () => flkty.previous());
         nextButton.addEventListener('click', () => flkty.next());

         // Initiale Beschriftung setzen
         function updateHeroControls() {
            let selectedIndex = flkty.selectedIndex;
            let selectedButton = cellsButtonGroup.children[selectedIndex];

            cellsButtonGroup.querySelector('.is-selected')?.classList.remove('is-selected');
            selectedButton.classList.add('is-selected');

            let prevIndex = (selectedIndex - 1 + items.length) % items.length;
            let nextIndex = (selectedIndex + 1) % items.length;

            previousButton.innerHTML = `<span>&larr;</span> ${titles[prevIndex]}`;
            nextButton.innerHTML = `${titles[nextIndex]} <span>&rarr;</span>`;
         }
         // later:
         flkty.on('select', updateHeroControls);
         updateHeroControls(); // initial call
      });
   }
}

export function imageCarousel() {
	const carousels = document.querySelectorAll('.carousel-slider, .wp-carousel-slider .wp-block-gallery');
	if (carousels.length) {
		carousels.forEach(carousel => {
			carousel.classList.remove('visually-hidden');
			// trigger redraw for transition
			carousel.offsetHeight;
			// Flickity options, defaults
			let options = {
				prevNextButtons: false,
				pageDots: false,
				imagesLoaded: true,
				cellAlign: 'left',
				autoPlay: 3000,
				pauseAutoPlayOnHover: true,
				freeScroll: true,
                wrapAround: true,
				//cellSelector: '.cms-block',
				arrowShape: arrowShape
			};
			// enable prev/next buttons at 768px
			if (matchMedia('screen and (min-width: 992px)').matches) {
				//options.prevNextButtons = true;
				//options.freeScroll = false;
			}
			new Flickity(carousel, options);
		});
	}
}

export function syncSlider() {
	const navslider = document.querySelector('.nav-slider');
   const navsliderNav = document.querySelector('.nav-slider-nav');
	if (navslider && navsliderNav) {
		new Flickity(navslider, {
			prevNextButtons: false,
			pageDots: false,
			contain: true,
			wrapAround: true,
			imagesLoaded: true,
			hash: true,
			adaptiveHeight: true
		});
		new Flickity(navsliderNav, {
			asNavFor: '.nav-slider',
			prevNextButtons: false,
			pageDots: false,
			imagesLoaded: true,
			contain: true,
			cellAlign: 'left'
		});
	}
}


export function syncMultipleSliders() {

   const navSliderElem = document.querySelector('.js-multiple-slider-nav');
   const mainSlider1Elem = document.querySelector('.js-multiple-slider-slide-1');
   const mainSlider2Elem = document.querySelector('.js-multiple-slider-slide-2');

   if (navSliderElem && mainSlider1Elem && mainSlider2Elem) {
      function syncAll(index, source) {
         if (source !== 'main1') mainSlider1.select(index);
         if (source !== 'main2') mainSlider2.select(index);
         if (source !== 'nav') navSlider.select(index);
         highlightActiveSlide(index); // Aktiven Slide hervorheben
      }
      // Funktion, um aktive Klasse zu setzen
      function highlightActiveSlide(index) {
         // Entferne die 'active' Klasse von allen Slides
         const allNavSlides = document.querySelectorAll('.js-multiple-slider-nav .item');
         const allMainSlides1 = document.querySelectorAll('.js-multiple-slider-slide-1 .item');
         const allMainSlides2 = document.querySelectorAll('.js-multiple-slider-slide-2 .item');

         allNavSlides.forEach(slide => slide.classList.remove('active'));
         allMainSlides1.forEach(slide => slide.classList.remove('active'));
         allMainSlides2.forEach(slide => slide.classList.remove('active'));

         // Füge die 'active' Klasse zur aktuellen Slide hinzu
         allNavSlides[index].classList.add('active');
         allMainSlides1[index].classList.add('active');
         allMainSlides2[index].classList.add('active');
      }

      let options = {
         contain: true,
         cellAlign: 'left',
         pageDots: false,
         prevNextButtons: false,
         imagesLoaded: true,
         arrowShape: arrowShape,
      };
      // enable prev/next buttons at 768px
      if (matchMedia('screen and (max-width:'+screen_sm+'px)').matches) {
         options.prevNextButtons = true;
      }
      const navSlider = new Flickity(navSliderElem, options);
      const mainSlider1 = new Flickity(mainSlider1Elem, {
         wrapAround: true,
         pageDots: false,
         prevNextButtons: false,
         imagesLoaded: true,
      });
      const mainSlider2 = new Flickity(mainSlider2Elem, {
         wrapAround: true,
         pageDots: false,
         prevNextButtons: false,
         imagesLoaded: true,
      });

      // Event-Handler für alle drei Slider
      mainSlider1.on('change', index => syncAll(index, 'main1'));
      mainSlider2.on('change', index => syncAll(index, 'main2'));
      navSlider.on('change', index => syncAll(index, 'nav'));

// Klick in der Navigation
      navSlider.on('staticClick', function (event, pointer, cellElement, cellIndex) {
         if (typeof cellIndex === 'number') {
            syncAll(cellIndex);
         }else {
            console.log('Invalid index: ', cellIndex);
         }
      });
      console.log(navSliderElem); // Sollte das Element mit der Klasse .multiple-slider-nav sein
      console.log(mainSlider1Elem); // Sollte das Element mit der Klasse .multiple-slider-slide-1 sein
      console.log(mainSlider2Elem); // Sollte das Element mit der Klasse .multiple-slider-slide-2 sein
   }
}


export default {
   slider,
   syncSlider,
   syncMultipleSliders,
   imageCarousel,
   heroSlider
};
